/* eslint-disable no-unused-vars */
import PCheck from "../../components/pos/PCheck";
import PSettingsCard from "../../components/pos/PSettingsCard.jsx";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function DashBoardSettings(props) {
  const { t } = useTranslation();
  const translate = t;
  const [liveValidation, setLiveValidation] = useState(false);

  const [showLast10DaysInvoice, setShowLast10DaysInvoice] = useState(false);
  const [showSaleByDept, setShowSaleByDept] = useState(false);
  const [showSalePurchaseByDept, setShowSalePurchaseByDept] = useState(false);
  const [showStockByDept, setShowStockByDept] = useState(false);

  const content = (
    <table width="100%">
      <tbody>
        <tr>
          <td width={200}>
            <PCheck
              onChange={(value) => setShowLast10DaysInvoice(value)}
              checked={showLast10DaysInvoice}
              label={translate("Show Last 10 Days Invoices")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td width={200}>
            <PCheck
              onChange={(value) => setShowSaleByDept(value)}
              checked={showSaleByDept}
              label={translate("Show Sale By Dept")}
            ></PCheck>
          </td>
        </tr>{" "}
        <tr>
          <td width={200}>
            <PCheck
              onChange={(value) => setShowSalePurchaseByDept(value)}
              checked={showSalePurchaseByDept}
              label={translate("Show Sale/Purchase By Dept")}
            ></PCheck>
          </td>
        </tr>{" "}
        <tr>
          <td width={200}>
            <PCheck
              onChange={(value) => setShowStockByDept(value)}
              checked={showStockByDept}
              label={translate("Show Stock By Dept")}
            ></PCheck>
          </td>
        </tr>
      </tbody>
    </table>
  );

  function validate() {
    setLiveValidation(true);
    return true;
  }

  function validateItemCodeLen() {}

  function createPayload(payload) {
    payload["showLast10DaysInvoice"] = showLast10DaysInvoice;
    payload["showSaleByDept"] = showSaleByDept;
    payload["showSalePurchaseByDept"] = showSalePurchaseByDept;
    payload["showStockByDept"] = showStockByDept;
  }

  function populateObject(bean) {
    console.log(bean);
    setShowLast10DaysInvoice(bean.showLast10DaysInvoice);
    setShowSaleByDept(bean.showSaleByDept);
    setShowSalePurchaseByDept(bean.showSalePurchaseByDept);
    setShowStockByDept(bean.showStockByDept);
  }

  return (
    <PSettingsCard
      avatar="D"
      title={translate("Dashboard Settings")}
      cardContent={content}
      onValidate={validate}
      createPayload={createPayload}
      populateObject={populateObject}
      messagHandler={props.messagHandler}
      settingKey="dashboard"
    ></PSettingsCard>
  );
}
